var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRightOrangeCircle = function SvgArrowRightOrangeCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0A10.002 10.002 0 0 0 0 10a10.002 10.002 0 0 0 10 10 10.002 10.002 0 0 0 10-10 10.008 10.008 0 0 0-2.933-7.067A10.008 10.008 0 0 0 10 0Zm.836 14.71-1.073-1.102 2.93-2.839-7.885-.013V9.217l7.67.014L9.86 6.538l1.102-1.075 4.562 4.687-4.687 4.56Z",
    fill: "#DC9B32"
  })));
};
export default SvgArrowRightOrangeCircle;